import React from 'react'
import DarkMode from '../../../components/Authentication/DarkMode'
import ForgotPasswordForm from '../../../components/Authentication/ForgotPasswordForm'

const ForgotPassword: React.FC = () => {
  return (
    <>
      <DarkMode />
      <ForgotPasswordForm />
    </>
  )
}

export default ForgotPassword

